// @flow
import React from 'react';

import EventDrivenPagePromotionalBlockCard from 'components/billboard/EventDrivenPagePromotionalBlockCard';
import type { CurrentCompetitionsType } from 'types/Settings';

import './EventDrivenPagePromotionalBlock.css';

export type StateProps = {
  currentCompetitions: CurrentCompetitionsType[]
};

function EventDrivenPagePromotionalBlock({ currentCompetitions }: StateProps) {
  if (currentCompetitions.length === 0) {
    return null;
  }

  if (currentCompetitions.length > 1) {
    return (
      <section className="container section-home-worldcup section-home-worldcup--double mt-7">
        <div className="row">
          <EventDrivenPagePromotionalBlockCard competition={currentCompetitions[0]} />
          <EventDrivenPagePromotionalBlockCard competition={currentCompetitions[1]} />
        </div>
      </section>
    ); // !@todo render
  }

  const titleOne = currentCompetitions[0].home_block_data.title_one ?? '';
  const titleTwo = currentCompetitions[0].home_block_data.title_two ?? '';
  const titleThree = currentCompetitions[0].home_block_data.title_three ?? '';
  const description = currentCompetitions[0].home_block_data.description;
  const link = currentCompetitions[0].home_block_data.link;
  const cta = currentCompetitions[0].home_block_data.cta;
  const image = currentCompetitions[0].home_block_data.image;
  const logo = currentCompetitions[0].home_block_data.logo;

  // eslint-disable-next-line consistent-return
  return (
    <div className="container">
      <section className="section-blueAlt section-home-worldcup mt-7">
        <div className="section-container">
          <div className="section-home-worldcup__left">
            {!!logo && (
              <div className="section--logo">
                <img src={logo} />
              </div>
            )}
            <div className="section--link">
              <p>{description}</p>
              <h2>{titleOne.trim() + ' ' + titleTwo.trim() + ' ' + titleThree.trim()}</h2>
              <a className="btn--competitions-internationales" href={link}>
                {cta}
              </a>
            </div>
          </div>
        </div>
        <div className="image-container">
          <div>
            <img src={image || '/img/worldcup-bg.jpg'} />
          </div>
          <div className="container-eclair">
            <img src="/img/svg/eclair_desktop.svg" className="eclair eclair-desktop" />
            <img src="/img/svg/eclair.svg" className="eclair eclair-mobile" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default EventDrivenPagePromotionalBlock;
